import { Fragment, useContext, useRef, useState } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { formatNum, uuid } from "../../../../oscar-pos-core/constants";
import { Box, capitalize, CircularProgress } from "@mui/material";
import { ListTableAmountCell, PopoverMenu, ReceiptPage } from "../../../common";
import AddContactSelector from "../../../common/AddContactSelector";
import {
  BlackCheckIcon,
  DeleteNewIcon,
  DownloadIcon,
  EditIcon,
} from "../../../../assets/icons/icon";
import { useAuthContext } from "../../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import SidebarBodyContent from "../../../common/UBRightSidebar/SidebarBodyContent";
import {
  bulkDeleteOrders,
  bulkRestoreStock,
} from "../../../../database/helpers/orders";
import { bulkDeleteInventory } from "../../../../database/helpers/inventory";
import {
  bulkCreatePayments,
  bulkDeletePaymentsV2,
  getPaymentsByInvoiceExternal,
} from "../../../../database/helpers/payment";
import {
  calculateTotalOutstanding,
  findCustomerByID,
} from "../../../../database/helpers/customer";
import { Sync } from "../../../../SyncService";
import { useSnackbar } from "../../../../context/SnackbarContext";
import withObservables from "@nozbe/with-observables";
import { handleDownloadInvoice } from "../../../Features/NewInvoiceBook/invoiceBookUtils";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { catchError, of } from "rxjs";
import styles from "./styles.module.css";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";
import RecordPaymentModal from "../../../common/Modals/RecordPaymentModal";
import { useWalletContext } from "../../../../context/WalletContext";
import { dateFormatInNumberWithSpace, resolveCategoryDisplayName } from "../../../../utils";
import AttachContactMessage from "../../../common/AttachContactMessage";

const ItemList = ({
  quickSale,
  key,
  index,
  orders,
  customerDetail,
  contactList,
  selectedContactId,
  setSelectedContactId,
  justClosedDropdownRef,
  isAccountLoading,
  selectedId,
  onEdit = () => {},
  refetchList = () => {},
  handleCollectClick = () => {},
}) => {
  const addedCustomer = customerDetail || undefined;
  const [I18n] = useContext(LanguageContext);
  const { EMIVerified } = useWalletContext();
  const [openDetailSidebar, setOpenDetailSidebar] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { user, business } = useAuthContext();
  const navigate = useNavigate();
  const componentRef = useRef(); // To reference the content to print
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoadingRecordPayment, setIsLoadingRecordPayment] = useState(false);
  const [isOpenRecordPaymentModal, setIsOpenRecordPaymentModal] =
    useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState("");

  const [recordPaymentObj, setRecordPaymentObj] = useState({
    customer: customerDetail
      ? {
          id: customerDetail.id,
          label: customerDetail.name,
          value: customerDetail.name,
        }
      : null,
  });

  const { showSnackbar } = useSnackbar();

  const handleDownload = () => {
    setIsLoading(true);
    try {
      handleDownloadInvoice(
        quickSale,
        business,
        (error) => {
          if (error) {
            if (!user?.phone_number) {
              showSnackbar({
                message: I18n.report_download_is_not_available_yet,
                severity: "error",
              });
            } else {
              showSnackbar({
                message: I18n.error_downloading_report,
                severity: "error",
              });
            }
            setIsLoading(false);
            return;
          }

          setIsLoading(false);
          showSnackbar({
            message: I18n.successfully_download_invoice,
            severity: "success",
          });
        },
        navigate,
        "Rupin Sale Invoice",
      );
      triggerLogEvent(analytics, "quick_sale_option_download");
    } catch (err) {
      setIsLoading(false);
    }
  };
  const AccoountActions = [
    {
      label: (
        <Fragment>
          <EditIcon width={20} height={20} />
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n.edit}
          </ParagraphText>
        </Fragment>
      ),
      hideOnPaid: true,
      action: (e) => {
        e.stopPropagation();
        triggerLogEvent(analytics, "quick_sale_option_edit");
        onEdit();
      },
    },
    {
      label: (
        <Fragment>
          <DownloadIcon width={20} height={18} id="download_black_btn" />
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n.download_invoice}
          </ParagraphText>
        </Fragment>
      ),
      action: (e) => {
        e.stopPropagation();
        triggerLogEvent(analytics, "quick_sale_option_download");
        handleDownload();
      },
    },
    {
      label: (
        <ReceiptPage
          invoiceId={quickSale?.id ?? ""}
          isPrintIcon={false}
          isPrintBtn={false}
          handleDownloadLogEvent={() =>
            triggerLogEvent(analytics, "invoice_receipt_download")
          }
          setIsReceiptLoading={setIsLoading}
          receiptFileName="Rupin Sale Receipt"
        />
      ),
      hideOnUnPaid: true,
      action: (e) => {
        e.stopPropagation();
        triggerLogEvent(analytics, "quick_sale_option_download");
      },
    },
    {
      label: (
        <Fragment>
          <BlackCheckIcon width={16} height={16} id="record_payment_btn" />
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n.record_payment}
          </ParagraphText>
        </Fragment>
      ),
      hideOnPaid: true,
      action: (e) => {
        e.stopPropagation();
        triggerLogEvent(analytics, "quick_sale_option_mark_paid");
        handleOpenRecordPaymentModal();
      },
    },
    {
      label: (
        <Fragment>
          <DeleteNewIcon width={20} height={18} id="delete_black_btn" />
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n.delete}
          </ParagraphText>
        </Fragment>
      ),
      danger: true,
      action: (e) => {
        deletePrompt();
        e.stopPropagation();
      },
    },
  ];

  const deletePrompt = () => {
    setShowDeleteModal(true);
    return;
  };

  const handleDelete = async (e) => {
    e.stopPropagation();
    triggerLogEvent(analytics, "quick_sale_option_delete");
    setShowDeleteModal(false);
    setIsActionLoading(true);

    if (orders.length) {
      let toDelete = [];
      await Promise.all(
        orders.map(async (item) => {
          let stock = await item.stock.fetch();

          toDelete.push({
            original: item,
            updated: stock,
          });
        }),
      );

      if (toDelete.length) {
        await bulkRestoreStock(toDelete, quickSale.type);
        await bulkDeleteOrders(toDelete);
        await bulkDeleteInventory(quickSale, toDelete, quickSale.type, "cash");
      }
    }
    if (customerDetail) {
      let payments = await quickSale.payment.fetch();
      await bulkDeletePaymentsV2(payments);

      let total = await calculateTotalOutstanding(customerDetail);
      await customerDetail.updateTotalOutstanding(total);
    }

    await quickSale.markAsDeleted();
    refetchList();
    setOpenDetailSidebar(false);
    setIsActionLoading(false);
    triggerLogEvent(analytics, "quick_sale_deleted");
    Sync(user.phone_number, navigate);
    showSnackbar({
      message: I18n.transaction_deleted,
      severity: "success",
      icon: "",
    });
  };

  const handleSelectCustomer = async (customer) => {
    setSelectedCustomer(customer);
    setSelectedContactId(null);
  };

  const handleAddCustomer = async (customer) => {
    try {
      await quickSale.updateInvoiceCustomer(customer);

      if (quickSale?.status?.toLowerCase() != "paid") {
        const data = {
          amount: quickSale.amount,
          date: quickSale.transacted_at,
          image_url: quickSale.image_url,
          note: quickSale.note,
          advance_amount: quickSale.advance_amount || 0,
        };
        await handleCreateCustomerPayment(business, customer, data, quickSale);
      }
      setSearchQuery("");
      setSelectedCustomer("");
      setSelectedContactId("");
      Sync(user.phone_number, navigate);
      showSnackbar({
        message: I18n.contact_attached_successfully,
        severity: "success",
      });
    } catch (error) {
      console.error(error);
      await quickSale.updateInvoiceCustomer(null);
    }
  };

  const handleOpenRecordPaymentModal = () => {
    setIsOpenRecordPaymentModal(true);
  };

  const handleRecordPayment = (
    selectedMethod,
    selectedDate,
    receivedAmount,
  ) => {
    handleEditInvoice(
      Number(receivedAmount) + Number(quickSale.advance_amount),
      selectedMethod,
      selectedDate,
      customerDetail,
    );
  };

  const handleEditInvoice = async (
    amountRecvd,
    paymentMethod,
    transaction_date,
  ) => {
    setIsLoadingRecordPayment(true);
    triggerLogEvent(analytics, "quick_sale_record");
    const invoiceAmountObj = {
      discount: quickSale?.discount || 0,
      discount_unit: quickSale?.discount_unit || "rs",
      tax_rate: quickSale?.tax_rate || 0,
      total: 0,
      sub_total: quickSale?.sub_total || 0,
      advance_amount: quickSale?.advance_amount || 0,
      profit: quickSale?.profit || 0,
    };
    let invoiceAmount = Number(quickSale?.amount) || 0;
    let invoiceStatus =
      invoiceAmount - (Number(amountRecvd) || 0) === 0 ? "paid" : "unpaid";
    let partialAmount = invoiceAmount - (Number(amountRecvd) || 0);
    const currentMethod = !paymentMethod ? quickSale?.method : paymentMethod;

    const fetchPaidTo = recordPaymentObj?.customer?.id
      ? await findCustomerByID(recordPaymentObj?.customer?.id)
      : null;

    const dataToEdit = {
      customer: recordPaymentObj?.customer?.id ? fetchPaidTo : null,
      recording_uri: quickSale?.recording_uri,
      advance_amount: Number(amountRecvd) || 0,
      invoice_number:
        quickSale?.invoice_number || business.invoice_number_count,
      invoice_prefix:
        quickSale?.invoice_prefix || business.invoice_number_prefix,
      invoice_title: quickSale?.invoice_title,
      discount_unit: quickSale?.discount_unit,
      sales_amount: quickSale?.sales_amount,
      document_url: quickSale?.document_url,
      cost_amount: quickSale?.cost_amount,
      attachment: quickSale?.attachment,
      sub_total: quickSale?.sub_total,
      signature: quickSale?.signature,
      tax_title: quickSale?.tax_title,
      image_url: quickSale?.image || null,
      date: transaction_date
        ? transaction_date
        : quickSale.transacted_at || new Date(),
      category: quickSale?.category,
      discount: quickSale?.discount,
      tax_rate: quickSale?.tax_rate,
      amount: invoiceAmount,
      method: currentMethod,
      wallet: currentMethod === "wallet" ? paymentMethod?.name : null,
      profit: quickSale?.profit,
      status: invoiceStatus,
      total: Number(invoiceAmountObj?.total) || 0,
      note: quickSale?.note || "",
      bank: currentMethod === "bank" ? paymentMethod?.name : null,
      partialAmount,
    };
    if (dataToEdit.customer && !addedCustomer) {
      const data = {
        amount: invoiceAmount,
        date: dataToEdit.date,
        image_url: dataToEdit.image_url,
        note: dataToEdit.note,
        advance_amount: dataToEdit.advance_amount,
      };
      await handleCreateCustomerPayment(
        business,
        dataToEdit.customer,
        data,
        quickSale,
      );
    } else if (dataToEdit.customer) {
      let dataForPayment = {
        udhaar_note: dataToEdit?.note,
        date: dataToEdit?.date || new Date(),
        image_url: dataToEdit?.image_url || null,
        invoiceDetail: quickSale,
        type: "cashbook",
      };
      // if total amount is changed wrt to current invoice, we will create or update invoice full payment entry
      if (invoiceAmount != quickSale?.amount) {
        dataForPayment["amount"] = invoiceAmount;
        let invoicePayment = await getPaymentsByInvoiceExternal(
          quickSale?.id,
          "full_invoice",
        );

        if (invoicePayment.length) {
          await invoicePayment[0]?.updatePayment(dataForPayment);
        } else {
          await dataToEdit.customer.createPayment({
            ...dataForPayment,
            uid: uuid(),
            date: new Date(),
            payment_mode: "Jama",
            external_type: "full_invoice",
          });
        }
      }
      if (
        Number(quickSale?.advance_amount) != Number(dataToEdit?.advance_amount)
      ) {
        dataForPayment["amount"] = Number(dataToEdit?.advance_amount);

        let invoicePayment = await getPaymentsByInvoiceExternal(
          quickSale?.id,
          "partial_invoice",
        );

        if (invoicePayment.length) {
          await invoicePayment[0]?.updatePayment(dataForPayment);
        } else {
          let payObj = {
            date: dataToEdit?.date || new Date(),
            note: dataToEdit?.note || "",
            image_url: dataToEdit?.image_url || "",
            type: "cashbook",
            uid: uuid(),
            amount: Number(dataToEdit.advance_amount),
            payment_mode: "Jama",
            external_type: "partial_invoice",
          };

          await bulkCreatePayments(business, dataToEdit.customer, quickSale, [
            payObj,
          ]);
        }
      }

      let totalOutstanding = await calculateTotalOutstanding(
        dataToEdit.customer,
      );

      await dataToEdit.customer.updateTotalOutstanding(totalOutstanding);
    }
    await quickSale.updateInvocie(dataToEdit);
    if (fetchPaidTo) triggerLogEvent(analytics, "quick_sale_record_name");
    if (dataToEdit.advance_amount)
      triggerLogEvent(analytics, "quick_sale_record_amount");
    if (dataToEdit.method)
      triggerLogEvent(analytics, "quick_sale_record_method");
    setIsLoadingRecordPayment(false);
    setIsOpenRecordPaymentModal(false);
    setOpenDetailSidebar(false);
    refetchList();
    Sync(user?.phone_number, navigate);
    showSnackbar({
      message: I18n.update_record_sucessfully,
      severity: "success",
    });
  };

  const handleCreateCustomerPayment = async (
    business,
    customer,
    data,
    invoice,
  ) => {
    let payObj = {
      date: data?.date || new Date(),
      note: data?.note || "",
      image_url: data?.image_url || "",
      type: "cashbook",
    };

    let paymentArr = [
      {
        ...payObj,
        uid: uuid(),
        amount: data.amount,
        payment_mode: "Udhaar",
        external_type: "full_invoice",
      },
    ];

    if (data?.advance_amount > 0) {
      paymentArr.push({
        ...payObj,
        uid: uuid(),
        amount: Number(data.advance_amount),
        payment_mode: "Jama",
        external_type: "partial_invoice",
      });
    }

    await bulkCreatePayments(business, customer, invoice, paymentArr);

    let totalOutstanding = await calculateTotalOutstanding(customer);

    await customer.updateTotalOutstanding(totalOutstanding);
  };

  let capitalizeMethod = quickSale?.["method"]
    ? capitalize(quickSale["method"]?.toString())
    : "";

  let capitalizeStatus = quickSale?.["status"]
    ? capitalize(quickSale["status"]?.toString())
    : "";

  const isPaid = capitalizeStatus
    ? capitalizeStatus === "Paid"
    : quickSale?.amount - (quickSale?.advance_amount || 0) <= 0;

  const balance = isPaid
    ? 0
    : Math.max(quickSale?.amount - (quickSale?.advance_amount || 0), 0);

  return (
    <Box
      id={`quick_sale_list_${index}`}
      className="invoiceListTableBody AccountItemListWrapper"
      key={key}
      onClick={(e) => {
        if (
          showDeleteModal ||
          selectedCustomer ||
          openDetailSidebar ||
          isOpenRecordPaymentModal ||
          justClosedDropdownRef.current
        )
          return;

        e.stopPropagation();
        if (selectedContactId) {
          setSelectedContactId("");
          return;
        }
        setOpenDetailSidebar(true);
        triggerLogEvent(analytics, "quick_sale_detail");
      }}
    >
      <Box
        className={`invListTableHeaderCol sevenColumn textLeft sidebarOption`}
      >
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {dateFormatInNumberWithSpace(quickSale?.transacted_at)}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn textLeft`}>
        <AddContactSelector
          selectedContact={
            customerDetail?.name
              ? { id: customerDetail?.id, name: customerDetail.name }
              : null
          }
          contacts={contactList || []}
          isOpen={selectedContactId === quickSale?.id}
          onOpenChange={(open) => {
            if (!customerDetail && !selectedContactId) {
              setSelectedContactId(open ? quickSale.id : "");
            } else if (selectedContactId) {
              justClosedDropdownRef.current = true;
              setSelectedContactId("");
              setTimeout(() => {
                justClosedDropdownRef.current = false;
              }, 100);
            } else if (!selectedContactId && !justClosedDropdownRef.current) {
              setOpenDetailSidebar(true);
            }
          }}
          onSelect={handleSelectCustomer}
          addContactLabel={I18n.add_contact || "Add contact"}
          searchPlaceholder={I18n.search_contact || "Search contact"}
        />
      </Box>
      <Box className={`invListTableHeaderCol sevenColumn textLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor displayFlex">
          {(() => {
            // Display only: status/method are stored in English and drive isPaid above, so translate here
            const statusText = capitalizeStatus || (isPaid ? "Paid" : "Unpaid");
            const statusLabel = capitalize(I18n[statusText.toLowerCase()] || statusText);
            const methodLabel = capitalizeMethod
              ? capitalize(I18n[String(quickSale["method"]).toLowerCase()] || capitalizeMethod)
              : "";
            const methodText = methodLabel ? `/ ${methodLabel}` : "";
            return `${statusLabel} ${methodText}`.trim();
          })()}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol sevenColumn textLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {quickSale?.category
            ? resolveCategoryDisplayName(
                quickSale.type === "in" ? "business_sale" : "business_expense",
                quickSale.category,
              )
            : "-"}
        </ParagraphText>
      </Box>
      <Box
        className={`invListTableHeaderCol sevenColumn textRight amountColumnNewWrapper`}
      >
        <ListTableAmountCell
          showAction={!isPaid && EMIVerified}
          actionLoading={isAccountLoading && selectedId === quickSale?.id}
          actionDisabled={isAccountLoading}
          onActionClick={() => {
            if (justClosedDropdownRef.current) {
              return;
            }
            handleCollectClick(quickSale);
          }}
          buttonTitle={I18n.collect}
          amountWrapperClassName={
            isPaid ? "newFontColor" : "foundationOrangeColor"
          }
        >
          {isPaid && (quickSale?.amount < 0 ? "-" : "+")}Rs.{" "}
          {formatNum(Math.abs(quickSale.amount) || 0)}
        </ListTableAmountCell>
      </Box>

      <Box
        className={`invListTableHeaderCol sevenColumn textRight sidebarOption`}
      >
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textRight newFontColor">
          Rs. {formatNum(balance)}
        </ParagraphText>
      </Box>

      <Box
        className={`amountColumnInnerWrapper invListTableHeaderCol sevenColumn textCenter`}
      >
        <ParagraphText className="fontSize14 fontWeight400 textCenter newFontColor tableActionsCell">
          <div className="tblOptnBox" role="button">
            <PopoverMenu
              id="quick_sale"
              menuOptions={AccoountActions.filter((acts) => {
                const status = quickSale?.status?.toLowerCase();

                if (status === "paid" && acts?.hideOnPaid) {
                  return false;
                }

                if ((status === "unpaid" || !status) && acts?.hideOnUnPaid) {
                  return false;
                }

                return true;
              })}
              popOverStyle={{
                marginLeft: "5px",
                borderRadius: "16px !important",
              }}
              popoverButton={
                (isLoading || isActionLoading) && (
                  <CircularProgress size={"15px"} />
                )
              }
              disabled={isLoading || isActionLoading}
            />
          </div>
        </ParagraphText>
      </Box>
      {openDetailSidebar ? (
        <SidebarBodyContent
          onClose={() => setOpenDetailSidebar(false)}
          open={openDetailSidebar}
          quickSale={quickSale}
          refetchList={refetchList}
          business={business}
          handleDelete={() => setShowDeleteModal(true)}
          handleMarkAsPaid={() => {
            triggerLogEvent(analytics, "quick_sale_side_bar_mark_paid");
            handleOpenRecordPaymentModal();
          }}
        />
      ) : null}

      {showDeleteModal && (
        <ConfirmationModal
          open={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={handleDelete}
          title={I18n.this_action_cannot_be_undone}
          message={I18n.are_you_sure_you_want_to_delete_transaction}
          confirmText={I18n.delete}
          id="quick_sale_delete_modal"
        />
      )}

      {selectedCustomer && (
        <ConfirmationModal
          open={Boolean(selectedCustomer)}
          onClose={() => setSelectedCustomer("")}
          onConfirm={() => handleAddCustomer(selectedCustomer)}
          confirmButtonClassName="ubPrimaryButton"
          title={I18n.you_wont_be_able_to_change_it_later}
          htmlMessage={
            <AttachContactMessage name={selectedCustomer.name} />
          }
          confirmText={I18n.confirm}
          id="quick_sale_add_contact_cofirm_modal"
        />
      )}

      {isOpenRecordPaymentModal ? (
        <Box onClick={(e) => e.stopPropagation()}>
          <RecordPaymentModal
            handleConfirm={handleRecordPayment}
            className={styles.modalContainer}
            handleClose={() => setIsOpenRecordPaymentModal(false)}
            isOpen={isOpenRecordPaymentModal}
            title={I18n.record_payment}
            selectedInvoice={quickSale}
            isLoading={isLoadingRecordPayment}
          />
        </Box>
      ) : null}

      <div style={{ display: "none" }}>
        <div ref={componentRef}>
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
      </div>
    </Box>
  );
};

const enhance = withObservables(
  ["quickSale", "business"],
  ({ quickSale, business }) => ({
    customerDetail: quickSale?.customer
      ? quickSale.customer.observe().pipe(catchError(() => of(null)))
      : of(null),

    orders: quickSale?.orders ? quickSale.orders.observe() : of([]),
  }),
);

export default enhance(ItemList);
